<template>
    <div>
        <template v-if="loading">
            <loading-spinner/>
        </template>
        <template v-if="!loading">
            <x-layout>
                <x-flex xs12>
                    <h2>Submission Changes</h2>
                </x-flex>
            </x-layout>

            <x-layout mt-5>
                <x-flex xs12>
                    <h4>Details</h4>
                    <x-data-table
                        class="inverse no-currentData-hover mt-3"
                        :headers="reviewSubmissionHeaders"
                        :items="reviewListSummary"
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.text | capitalize }}</td>
                            <td>{{ props.item.oldValue }}</td>
                            <td>{{ props.item.newValue }}</td>
                        </template>
                    </x-data-table>
                    <template v-if="hasObligor">
                        <br><h4>{{ submissionObligorReviewList.title }}</h4>
                        <x-data-table
                            class="inverse no-currentData-hover mt-3 obligor-data-list"
                            :headers="multiObligorGuarantorHeaders"
                            :items="submissionObligorReviewList.value"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.id }}</td>
                                <td>{{ props.item.text | capitalize }}</td>
                                <td>{{ props.item.oldValue }}</td>
                                <td>{{ props.item.newValue }}</td>
                            </template>
                        </x-data-table>
                        <template>
                            <br><h4>{{ submissionGuarantorsList.title }}</h4>
                            <x-data-table
                                class="inverse no-currentData-hover mt-3 guarantor-data-list"
                                :headers="multiObligorGuarantorHeaders"
                                :items="submissionGuarantorsList.value"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                    <td>{{ props.item.id ? props.item.id : '' }}</td>
                                    <td>{{ props.item.text | capitalize }}</td>
                                    <td>{{ props.item.oldValue }}</td>
                                    <td>{{ props.item.newValue }}</td>
                                </template>
                            </x-data-table>
                        </template>
                    </template>
                </x-flex>
            </x-layout>

            <x-layout v-if="informationSectionsItem" mt-5>
                <x-flex xs12>
                    <h4>{{ informationSectionsItem.text }}</h4>

                    <additional-information-display
                        v-model="informationSectionsItem.value"
                        :insurer="true"
                    />
                </x-flex>
            </x-layout>

            <x-layout mt-5>
                <slot/>
            </x-layout>
        </template>
    </div>
</template>

<script>
import AdditionalInformationDisplay from '~/components/Shared/UIComponents/AdditionalInformationDisplay';
import productConfig from '~/mixins/productConfig';
import riskReviewList from '~/mixins/riskReviewList';

export default {
    name: 'SubmissionReviewList',
    components: {
        AdditionalInformationDisplay
    },
    mixins: [
        productConfig,
        riskReviewList,
    ],
    props: {
        submission: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            submissionReviewList: [],
            submissionReviewList1: [],
            submissionObligorList: {
                title: 'Obligor(s)',
                value: []
            },
            submissionGuarantorsList: {
                title: 'Guarantor(s)',
                value: []
            },
            currencies: [],
            sectors: [],
            countries: [],
            obligors: [],
            loading: true,
            reviewSubmissionHeaders: [
                {
                    text: 'Field',
                    value: 'text',
                    sortable: false
                },
                {
                    text: 'Previous Value',
                    value: 'oldValue',
                    sortable: false
                },
                {
                    text: 'Updated Value',
                    value: 'newValue',
                    sortable: false
                }
            ],
            multiObligorGuarantorHeaders: []

        }
    },
    computed: {
        product() {
            return this.submission.product;
        },
        submissionInitialData() {
            return this.submission.submission_initial_data;
        },
        insurerList() {
            return [];
        },
        hasNoObligor() {
            return this.submission.product !== 'undefined' && this.submission.product_id && this.submission.product.has_no_obligor;
        },
        hasObligor() {
            return !this.hasNoObligor;
        },
        riskUnderReview() {
            return this.submission;
        },
        comparisonData() {
            return this.submissionInitialData;
        },
        submissionObligorReviewList() {
            this.submissionObligorList = {
                title: 'Obligor(s)',
                value: []
            };
            this.addObligorsGuarantors('obligors')

            return this.submissionObligorList;
        },
        submissionGuarantorReviewList() {
            this.submissionGuarantorsList = {
                title: 'Guarantor(s)',
                value: []
            };
            this.addObligorsGuarantors('guarantors')

            return this.submissionGuarantorsList;
        }
    },
    mounted() {
        this.multiObligorGuarantorHeaders = [
            ...[
                {
                    text: '',
                    value: 'text',
                    sortable: false
                }
            ],
            ...this.reviewSubmissionHeaders
        ];
        this.fetchData();
    },
    methods: {
        getCurrencyCode(useNewCode = false) {
            let {currency} = this.submission;

            if (!useNewCode) {
                return currency.code;
            }

            if (this.submissionInitialData.currency_id) {
                currency = this.currencies.find(currency => this.submissionInitialData.currency_id === currency.id) || {};
            }

            return currency.code;
        },
        getCountryName(id = null) {
            if (id) {
                return this.countries.find(country => country.id === id).name
            }
            return '';
        },
        getObligorsName(id = null) {
            if (id) {
                return this.obligors.find(obligor => obligor.id === id).name
            }
            return '';
        },
        async fetchData() {
            this.currencies = (await axios.get(this.$root.api('currency'))).data.data;
            this.sectors = (await axios.get(this.$root.api('sectors'))).data.data;
            this.countries = this.$root.countries;
            this.obligors = (await axios.get(this.$root.api('obligor'))).data.data;
            this.entities = (await axios.get(this.$root.api('entity'))).data.data;
            this.loading = false;

        },
        addObligorsGuarantors(property) {
            let fieldChanges = this.submissionInitialData;
            const self = this;
            let idToPickup,
                title = '';
            let pushObj = [];
            if (property === 'obligors') {
                idToPickup = 'obligor_id';
                title = 'Obligor';
                pushObj = self.hasObligor ? self.submissionObligorList.value : self.submissionReviewList1;
            } else if (property === 'guarantors') {
                idToPickup = 'guarantor_id';
                title = 'Guarantor';
                pushObj = self.hasObligor ? self.submissionGuarantorsList.value : self.submissionReviewList1;
            }

            self.submission[property].forEach(function (currentData, index) {
                let previousData = '';
                if (typeof self.submissionInitialData[property] !== 'undefined' && self.submissionInitialData[property].length) {
                    previousData = self.submissionInitialData[property][index];
                }
                let oldValue = previousData !== '' && typeof previousData !== 'undefined' ? self.getObligorsName(previousData.pivot[idToPickup]) : '';
                let newValue = typeof currentData.pivot !== 'undefined' && typeof currentData.pivot[idToPickup] !== 'undefined' ? self.getObligorsName(currentData.pivot[idToPickup]) : '';
                if (newValue === '') {
                    return;
                }
                if (self.hasObligor) {
                    pushObj.push({
                        id: (index + 1),
                        text: title,
                        newValue: newValue,
                        oldValue: oldValue !== newValue ? oldValue : ''
                    });
                } else {
                    pushObj.push({
                        text: title,
                        newValue: newValue,
                        oldValue: oldValue !== newValue ? oldValue : ''
                    });
                }

                oldValue = previousData !== '' && typeof previousData !== 'undefined' ? self.getCountryName(previousData.country_id) : '';
                newValue = typeof currentData.country_id !== 'undefined' ? self.getCountryName(currentData.country_id) : '';

                pushObj.push({
                    text: 'Country',
                    newValue: newValue,
                    oldValue: oldValue !== newValue ? oldValue : ''
                });

                if (self.hasObligor && property === 'obligors') {
                    oldValue = previousData !== '' && typeof previousData !== 'undefined' ? previousData.pivot.sub_limit : '';
                    newValue = typeof currentData.pivot !== 'undefined' && typeof currentData.pivot.sub_limit !== 'undefined' ? currentData.pivot.sub_limit : '';
                    pushObj.push({
                        text: 'Sub Limit',
                        newValue: newValue,
                        oldValue: oldValue !== newValue ? oldValue : ''
                    });
                }
            });
            if (self.hasObligor) {
                const isChanged = this.isObligorsGuarantorsChanged(property, pushObj);
                if (property === 'obligors') {
                    this.submissionObligorList.title = `${this.submissionObligorList.title} ${isChanged ? ' (updated)' : ''}`;
                } else if (property === 'guarantors') {
                    this.submissionGuarantorsList.title = `${this.submissionGuarantorsList.title} ${isChanged ? ' (updated)' : ''}`;
                }
            }
        },
        isObligorsGuarantorsChanged(property, pushObj) {
            if (typeof this.submissionInitialData[property] !== 'undefined' && this.submissionInitialData[property].length !== this.submission[property].length) {
                return true;
            }
            return pushObj.some(function (row) {
                return row.oldValue !== '';
            });
        },
        applyFormatFilter(value, format, addValue = '') {
            switch (format) {
                case 'currency':
                    return this.$options.filters.currency(value, addValue);
                case 'days':
                case 'risk_period':
                    return this.$options.filters.yearsAndDays(value);
                case 'percent':
                    return this.$options.filters.percent(value);
                case 'yes_no':
                case 'boolean':
                    return value ? 'Yes' : 'No';
                case 'decimal':
                    return value ? Number.parseFloat(value).toFixed(addValue ? addValue : 2) : ''
                default:
                    return value || '';
            }
        },
    }
}
</script>

